/**
 * 全局提示与确认框入口。
 * antd 的静态方法（message.xxx、Modal.confirm、notification.xxx）拿不到 ConfigProvider 的主题，
 * 暗色下会弹出亮色框；这里保存 App.useApp() 的实例，供 api/client.ts 等非 React 代码调用。
 * React 组件里直接用 App.useApp() 即可。
 */
import { useEffect } from 'react'
import { App } from 'antd'

type FeedbackApi = ReturnType<typeof App.useApp>

let feedbackApi: FeedbackApi | null = null

function requireApi(): FeedbackApi {
  if (!feedbackApi) throw new Error('feedback 尚未初始化：FeedbackBinder 需挂在 antd <App> 内')
  return feedbackApi
}

export const feedback = {
  get message() {
    return requireApi().message
  },
  get modal() {
    return requireApi().modal
  },
  get notification() {
    return requireApi().notification
  }
}

// 挂在 antd <App> 内部，挂载后保存实例
export function FeedbackBinder() {
  const api = App.useApp()
  useEffect(() => {
    feedbackApi = api
  }, [api])
  return null
}
